import { TableCarrierAccepted} from "../TableCarrierAccepted";
import { TableCarrierAvailable} from "../TableCarrierAvailable";
import { TableCarrierDeliveredOrders} from "../TableCarrierDeliveredOrders";
import { TableCarrierOfferHistory} from "../TableCarrierOfferHistory";
import { Layout, Tab, Tabset} from "@mcleod/components";

export abstract class AutogenLayoutCarrierPortal extends Layout {
	layout1: TableCarrierAccepted;
	layoutAvailableLoads: TableCarrierAvailable;
	layoutDeliveredLoads: TableCarrierDeliveredOrders;
	layoutOfferHistory: TableCarrierOfferHistory;
	tabAccepted: Tab;
	tabAvailable: Tab;
	tabDelivered: Tab;
	tabOfferHistory: Tab;
	tabset: Tabset;
}
